var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('table',{staticClass:"table table-responsive"},[_c('thead',{class:`${_vm.theadClass} text-uppercase`},[_c('tr',[_vm._t("table-headers")],2)]),_c('tbody',{class:`${_vm.tbodyClass} text-secondary`},[_vm._t("table-rows")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }